<template>
  <form class="max-w-5xl" @submit.prevent="emit('save')">
    <div class="mt-10 mb-40 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
      <form-input v-model.trim="plugin.name" label="Name" class="md:col-span-4" :error-msg="result.name.$messages.join(' | ')" />

      <form-input v-model.trim="plugin.processName" label="Process name" class="md:col-span-4" :error-msg="result.processName.$messages.join(' | ')" />

      <form-input
        v-model="plugin.automationAppId"
        label="Automation App Id"
        type="number"
        :range="[0, 9999]"
        class="md:col-span-4"
        :error-msg="result.automationAppId.$messages.join(' | ')"
      />

      <form-input v-model="plugin.info" label="Info" class="md:col-span-4" :error-msg="result.info.$messages.join(' | ')" />

      <form-textarea v-model="plugin.description" label="Description" class="col-span-full" />

      <form-image-upload v-model="plugin.iconUrl" label="App Icon" class="col-span-3" :error-msg="result.iconUrl.$messages.join(' | ')" />

      <form-switch v-model="plugin.isExecutable" label="Is Executable" class="md:col-span-3" />
    </div>
  </form>
</template>

<script setup>
import { reactive } from 'vue';
import useValidate from 'vue-tiny-validate';
import FormInput from './FormInput.vue';
import FormTextarea from './FormTextarea.vue';
import FormSwitch from './FormSwitch.vue';
import FormImageUpload from './FormImageUpload.vue';

const plugin = defineModel('plugin', {
  type: Object,
  default: () => ({
    name: '',
    processName: null,
    automationAppId: null,
    description: '',
    info: '',
    isExecutable: false,
    isEnabled: true,
    iconUrl: null
  })
});

const emit = defineEmits([ 'save' ]);

defineExpose({
  onValidate,
  getResult
});

const rules = reactive({
  name: {
    name: 'required',
    test: value => Boolean(value),
    message: 'Name must not be empty.'
  },
  automationAppId: {
    name: 'required',
    test: value => Boolean(value),
    message: 'Automation App Id must not be empty.'
  },
  info: {
    name: 'required',
    test: value => Boolean(value),
    message: 'Info must not be empty.'
  },
  description: {
    name: 'required',
    test: () => true,
    message: 'Description must not be empty.'
  },
  iconUrl: {
    name: 'required',
    test: () => true,
    message: 'Icon URL must not be empty.'
  },
  processName: {
    name: 'required',
    test: () => true,
    message: 'Process name must not be empty.'
  }
});

const options = reactive({
  autoTest: true
});
const { result } = useValidate(plugin, rules, options);

async function onValidate() {
  return await result.value.$test();
}

function getResult() {
  return result.value;
}
</script>
